import { Stack, Typography } from '@mui/material';

export type SavedMatchSummary = {
  result_status: string | null;
  our_team_score: number | null;
  opponent_team_score: number | null;
  team_result: string | null;
  team_result_value: string | null;
  calculated_result_snapshot?: { explanation?: string; lineWins?: { Us?: number; Opponent?: number } } | null;
};

// Presentation only. The saved outcome—not equal score totals—determines a tie.
// In particular, a USTA 2–2 result may still have a saved winning team.
export function SavedMatchResultSummary({ result, ourName, opponentName }: {
  result: SavedMatchSummary; ourName: string; opponentName: string;
}) {
  const outcome = result.team_result_value && result.team_result_value !== 'Unknown'
    ? result.team_result_value.toLowerCase() : result.team_result?.toLowerCase();
  const tie = outcome === 'tie';
  const winner = outcome === 'win' ? ourName : outcome === 'loss' ? opponentName : null;
  const explanation = result.calculated_result_snapshot?.explanation
    ?.replace(/^Opponent\b/, opponentName).replace(/^Us\b/, ourName);
  return <Stack spacing={1.25} aria-label="Saved match result summary">
    <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>Match Summary</Typography>
    <Typography variant="body2">Score: {ourName} {result.our_team_score ?? '—'}–{result.opponent_team_score ?? '—'} {opponentName}</Typography>
    <Typography variant="body2">Result: {tie ? 'Tie' : outcome === 'win' ? 'Win' : outcome === 'loss' ? 'Loss' : 'Not determined'}</Typography>
    {winner && <Typography variant="body2">Winning Team: {winner}</Typography>}
    {explanation && <Typography variant="body2">{tie ? 'Result explanation' : 'Result decided by'}: {explanation}</Typography>}
    <Typography variant="body2" color="text.secondary">Saved result status: {result.result_status || 'Not submitted'}</Typography>
  </Stack>;
}
